import React, {ReactElement, useState} from 'react';

import {gt} from 'app/utils/i18n';

import {PaginatedPage} from './PaginatedPage';
import StateButton from './StateButton';

import type {UseQueryType} from 'app/general/datafetchers/hooks/useInfiniteListFetcherRTK';
import type {ListResponseType} from 'sweet-types';

export interface PaginatedListProps<P, D> {
  hook: UseQueryType<P, D>;
  params: P;
  render: (data: undefined | ListResponseType<D>) => ReactElement;
}

export const PaginatedList = <P, D>({
  hook,
  params,
  render,
}: PaginatedListProps<P, D>) => {
  const [pages, setPages] = useState<Array<number>>([1]);
  const [hasNext, setHasNext] = useState<undefined | null | string>(null);

  const loadMore = () => {
    setPages((prevPages) => [...prevPages, prevPages.length + 1]);
  };

  const removePage = (page: number) => {
    const pageIndex = pages.indexOf(page);

    if (pageIndex != -1) {
      setPages(pages.slice(0, pageIndex));
    }
  };

  return (
    <div>
      {pages.map((page, index) => (
        <PaginatedPage
          key={index}
          page={page}
          params={params}
          hook={hook}
          render={render}
          setHasNext={setHasNext}
          removePage={removePage}
        />
      ))}
      {hasNext != null && (
        <div className="d-block px-4 mt-3">
          <StateButton
            className="mb-2 btn-block btn-outline-primary btn-sm"
            busyText={gt('Loading...')}
            onClick={loadMore}
          >
            {gt('Load more')}
          </StateButton>
        </div>
      )}
    </div>
  );
};
